export const firebaseConfig = {
  apiKey: 'AIzaSyBmNKtP_nPsrhm4jBsqOgq14Lg9OzVflXA',
  authDomain: import.meta.env.DEV && window.location.protocol === 'https:'
    ? window.location.host
    : import.meta.env.VITE_BIZ_FIREBASE_DOMAIN,
  projectId: 'aigc-xiaoyao-overseas',
  storageBucket: 'aigc-xiaoyao-overseas.firebasestorage.app',
  messagingSenderId: '104140219477',
  appId: '1:104140219477:web:1c0d4e56fa1cedb2e320dc',
}
